import { Navigate, useLocation } from 'react-router-dom';
import React from 'react';
import { useHybridAuth } from '../../contexts/HybridAuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: 'super_admin' | 'admin' | 'user';
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  children, 
  requiredRole 
}) => {
  const { isAuthenticated, loading, user } = useHybridAuth();
  const location = useLocation();

  console.log('ProtectedRoute:', { isAuthenticated, loading, user: !!user, path: location.pathname });

  // Wait for auth to load
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  // If not authenticated, redirect to sign in
  if (!isAuthenticated) {
    return <Navigate to="/sign-in" state={{ from: location }} replace />;
  }

  // Check role if required
  if (requiredRole) {
    const userRole = user?.role;
    
    // Super admin can access everything
    if (userRole === 'super_admin') {
      // Super admin has access to all routes
    } else if (requiredRole === 'admin' && userRole === 'admin') {
      // Admin can access admin routes
    } else if (requiredRole === 'user' && userRole) {
      // Any authenticated user can access user routes
    } else {
      // Unauthorized - redirect to dashboard
      console.log(`Access denied: required role ${requiredRole}, user role ${userRole}`);
      return <Navigate to="/dashboard" replace />;
    }
  }

  return <>{children}</>;
};